import { all, call, put, select, takeLatest, takeLeading } from 'redux-saga/effects'
import { get } from 'lodash'
import { FETCH_CUSTOMERS_REQUESTED, fetchCustomersSucceeded, fetchCustomersFailed } from '../actions/suites/customer'
import { FETCH_CUSTOMER_PAYMENTS_REQUESTED, fetchCustomerPaymentsSucceeded, fetchCustomerPaymentsFailed } from '../actions/suites/customerPayment'
import { FETCH_ORDERING_PREFERENCES_REQUESTED, CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED, fetchOrderingPreferencesSucceeded, fetchOrderingPreferencesFailed, createCustomerOrderingPreferencesSucceeded, createCustomerOrderingPreferencesFailed } from '../actions/suites/orderingPreference'
import {
  FETCH_SALES_EVENTS_REQUESTED,
  fetchSalesEventsSucceeded,
  fetchSalesEventsFailed,
  FETCH_SALES_EVENT_TYPES_REQUESTED,
  fetchSalesEventTypesSucceeded,
  fetchSalesEventTypesFailed,
} from '../actions/suites/salesEvent'

import { FETCH_RESOURCES_FOR_ORDERING_PREFERENCES } from '../actions/shared'

import { getDisplaySuites } from '../selectors/suites'
import { getCurrentEventId } from '../selectors/events'

import { getRevenueCenters } from './revenueCenter'

import Remote from '../remote'
import { makeGetAttendantStandUuids } from '../selectors/attendant'
import { getPreOrders } from './orders/order'

export function* fetchCustomers(params = {}) {
  try {
    const result = yield call(Remote.getCustomers)

    yield put(fetchCustomersSucceeded(result))
  } catch (err) {
    yield put(fetchCustomersFailed(err))
  }
}

export function* watchFetchCustomers() {
  yield takeLatest(FETCH_CUSTOMERS_REQUESTED, fetchCustomers)
}

export function* fetchCustomerPayments(params = {}) {
  try {
    const result = yield call(Remote.getCustomerPayments)

    yield put(fetchCustomerPaymentsSucceeded(result))
  } catch (err) {
    yield put(fetchCustomerPaymentsFailed(err))
  }
}

export function* watchFetchCustomerPayments() {
  yield takeLatest(FETCH_CUSTOMER_PAYMENTS_REQUESTED, fetchCustomerPayments)
}

const filterOrderingPreferences = (orderingPreferences, displaySuites, currentEventId) => {
  return orderingPreferences.filter((pref) => {
    const isDefaultPreference = pref.type === 'Customer::StandPreference' && pref.salesEventId === null

    if (isDefaultPreference) {
      return pref
    }

    const result = displaySuites.find((suite) => {
      const firstCondition = suite.customerId === pref.customerId && suite.revenueCenterId === pref.standUuid
      const secondCondition = suite.customerId === pref.customerId && !pref.standUuid
      const thirdCondition = pref.salesEventId === currentEventId || !pref.salesEventId

      return (firstCondition || secondCondition) && thirdCondition
    })

    return result
  })
}

export function* fetchOrderingPreferences() {
  const currentEventId = yield select(getCurrentEventId)

  try {
    const result = yield call(Remote.getOrderingPreferences, currentEventId)
    const orderingPreferences = result?.data?.orderingPreferences ?? []
    const displaySuites = yield select(getDisplaySuites, orderingPreferences)
    const filteredOrderPrefs = filterOrderingPreferences(orderingPreferences, displaySuites, currentEventId)

    const newResult = {
      data: {
        orderingPreferences: filteredOrderPrefs
      }
    }

    yield put(fetchOrderingPreferencesSucceeded(newResult))
  } catch (err) {
    yield put(fetchOrderingPreferencesFailed(err))
  }
}

export function* watchFetchOrderingPreferences() {
  yield takeLatest(FETCH_ORDERING_PREFERENCES_REQUESTED, fetchOrderingPreferences)
}


export function* fetchSalesEvents(params = {}) {
  const venueUuid = process.env.REACT_APP_VENUE_UUID

  try {
    const result = yield call(Remote.getSalesEvents, venueUuid)

    yield put(fetchSalesEventsSucceeded(result))
  } catch (err) {
    yield put(fetchSalesEventsFailed(err))
  }
}

export function* watchFetchSalesEvents() {
  yield takeLatest(FETCH_SALES_EVENTS_REQUESTED, fetchSalesEvents)
}


export function* fetchSalesEventTypes(params = {}) {
  try {
    const result = yield call(Remote.getSalesEventTypes)

    yield put(fetchSalesEventTypesSucceeded(result))
  } catch (err) {
    yield put(fetchSalesEventTypesFailed(err))
  }
}

export function* watchFetchSalesEventTypes() {
  yield takeLatest(FETCH_SALES_EVENT_TYPES_REQUESTED, fetchSalesEventTypes)
}

export function* createCustomerOrderPreference(params = {}) {
  const payload = get(params, 'payload', [])
  const customerId = get(payload[0], 'customerId')
  try {
    const result = yield call(Remote.createCustomerOrderingPreference, customerId, payload)

    yield put(createCustomerOrderingPreferencesSucceeded(result))
  } catch (err) {
    yield put(createCustomerOrderingPreferencesFailed(err))
  }
}

export function* watchCreateCustomerOrderPreference() {
  yield takeLatest(CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED, createCustomerOrderPreference)
}

export function* fetchResourcesForOrderingPreferencesSaga(params = {}) {
  const getAttendantStandUuids = makeGetAttendantStandUuids()
  const currentEventId = yield select(getCurrentEventId)
  const standUuids = yield select(getAttendantStandUuids)

  yield all([
    fetchCustomers(),
    getRevenueCenters(),
    getPreOrders({ payload: { standUuids, salesEventId: currentEventId } })
  ])

  yield fetchOrderingPreferences()


}

export function* watchFetchResourcesForOrderingPreferencesSaga() {
  yield takeLeading(FETCH_RESOURCES_FOR_ORDERING_PREFERENCES, fetchResourcesForOrderingPreferencesSaga)
}
